import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { HrParagraph, HrFlexContainer, HrButtons, HrTitleH3 } from '@components/styles/hr-styles';
import { Modal } from '../modal';
import useStore from '../../store/useStore';
import { DisplaySettingsContext } from '../../store/display-settings';

const Image = styled.figure`
  width: 136px;
  height: 136px;
  margin: 0;

  & img {
    width: 136px;
    height: 136px;
    object-fit: cover;
  }
`;

export const SuccessfulApplication = ({ setShowModal, action, vacancy }) => {
  const { getDataPostulant } = useStore();
  const [t] = useTranslation();
  const { darkMode } = useContext(DisplaySettingsContext);

  return (
    <Modal setShowModal={setShowModal} width='360px' noClose>
      <HrFlexContainer flexDirection='column' padding='32px' gap='32px'>
        <Image>
          <img src='/assets/img/ok.png' alt={t('postulant.modal.successful_update.img_alt')} />
        </Image>
        <HrFlexContainer gap='8px'>
          <HrTitleH3 color={darkMode ? 'white' : ''} textAlign='center'>
            {action === 'edit'
              ? t('postulant.modal.successful_application.title_update')
              : t('postulant.modal.successful_application.title_create')}
          </HrTitleH3>
          {action !== 'edit' && (
            <HrParagraph color={darkMode ? 'white' : ''} textAlign='center'>{t('postulant.modal.successful_application.text')}</HrParagraph>
          )}
        </HrFlexContainer>
        {vacancy.status !== 6 && (
          <HrFlexContainer justifyContent='center'>
            <HrButtons
              category='primary'
              size='medium'
              onClick={() => {
                window.location.href = getDataPostulant.portalLink;
              }}
            >
              {t('postulant.modal.successful_application.go_to_the_portal')}
            </HrButtons>
          </HrFlexContainer>
        )}
      </HrFlexContainer>
    </Modal>
  );
};
